export const ADMIN = "ADMIN";
export const REQUERIMIENTO = "REQ";
export const CONTROL = "CON";
export const MODIFICAR_REQ = "MOD";